module.exports = __webpack_public_path__ + "images/automatic-scouts/setting_complete_en_2-eaf093394e60f9a2ac62e61dc0d10450.png";